var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{class:'backdrop'},[_c('div',{staticStyle:{"min-height":"100vh"}},[_c('router-view',{scopedSlots:_vm._u([{key:"default",fn:function({ Component }){return [_c('transition',{attrs:{"name":"slide"}},[_c(Component,{tag:"component"})],1)]}}])})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }